import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { Assets } from "../../../../assets/Assets";
import styles from "./index.module.scss";
import { Tooltip, Button } from "antd";

function HistoryModalDataAccordion({ type, data, fileurl, key }) {
  let [contentlist, setContentlist] = useState([]);
  const handleDownload = (e) => {
    e.stopPropagation();
    console.log("Download click..........." + fileurl);
    window.open(fileurl, "_blank");
  };

  useEffect(() => {
    if ((type === "Prescription" || type === "Services") && data) {
      //console.log("type Prescription" + type);
      setContentlist(JSON.parse(data));
    }
  }, []);

  return (
    <div className={styles.accordion_wrap}>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <span className={styles.accord_item_header}>{type}</span>
            <div className={styles.accord_item_dwnld} onClick={handleDownload}>
              <Tooltip placement="topLeft" title={"Download " + type}>
                <img src={Assets.accord_download} alt="" />
              </Tooltip>
            </div>
          </Accordion.Header>
          {type === "Prescription" || type === "Services" ? (
            <>
              <Accordion.Body>
                {type === "Prescription" && contentlist.length > 0
                  ? contentlist.map((element) => {
                      return (
                        <div
                          style={{
                            borderBottom: "1px solid #ddd",
                            paddingTop: "20px",
                          }}
                        >
                          <p>
                            <b>{element.name}</b>
                          </p>
                          <p>
                            {element.quandity + "  " + element.measurement},{" "}
                            {element.displayTablet}{" "}
                          </p>
                        </div>
                      );
                    })
                  : ""}
                {type === "Services" && contentlist.length > 0
                  ? contentlist.map((element) => {
                      return (
                        <div
                          style={{
                            borderBottom: "1px solid #ddd",
                            paddingTop: "20px",
                          }}
                        >
                          <p>
                            <b>{element.testType}</b> ,{element.testComment}
                          </p>
                        </div>
                      );
                    })
                  : ""}
              </Accordion.Body>
            </>
          ) : (
            <Accordion.Body>{data}</Accordion.Body>
          )}
        </Accordion.Item>
        {/* <Accordion.Item eventKey="1">
          <Accordion.Header>
          <span className={styles.accord_item_header}>Private  Note</span>
            <div className={styles.accord_item_dwnld} onClick={handleDownload}>
             <img src={Assets.accord_download} alt="" />
            </div>
          </Accordion.Header>
          <Accordion.Body>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion> */}
      </Accordion>
    </div>
  );
}

export default HistoryModalDataAccordion;
